import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useGlobalCopyModal = (globalCopyModal, setGlobalCopyModal, history) => {
  const navigate = useNavigate();

  // 광역 복사 모달 완료 시 페이지 이동 처리 (더 이상 사용하지 않음)
  const handleGlobalCopyComplete = () => {
    // 모달 상태 초기화
    setGlobalCopyModal({ open: false, videoTitle: '' });
    // 복사 완료 후 최신 히스토리 항목으로 이동
    if (history.length > 0) {
      const latestHistory = history[0]; // 가장 최신 히스토리
      navigate(`/analyze/${latestHistory.id}`);
    }
  };

  return {
    handleGlobalCopyComplete
  };
}; 